import { Typography } from '@mui/material';
import Link from '../../app/link';

export const PrivacyDisclaimer = () => (
  <Typography variant="body2" sx={{ my: 2 }}>
    Please view our{' '}
    <Link
      href="https://talkiatry.com/privacy-policy/"
      target="_blank"
      rel="noreferrer"
    >
      privacy policy
    </Link>{' '}
    for information about HIPAA laws, privacy rights, and sensitive personal
    health information disclosure.
  </Typography>
);

export default PrivacyDisclaimer;
